import * as Yup from 'yup';

const validationSchema = (t) =>
  Yup.object({
    tsh: Yup.number()
      .min(0.001, t('labTests.tsh.validation.minValue'))
      .max(1000, t('labTests.tsh.validation.maxValue')),
    ft3: Yup.number()
      .min(0.001, t('labTests.ft3.validation.minValue'))
      .max(100, t('labTests.ft3.validation.maxValue')),
    ft4: Yup.number()
      .min(0.001, t('labTests.ft4.validation.minValue'))
      .max(100, t('labTests.ft4.validation.maxValue')),
    antiTg: Yup.number()
      .min(0.001, t('labTests.antiTg.validation.minValue'))
      .max(100000, t('labTests.antiTg.validation.maxValue')),
    antiTpo: Yup.number()
      .min(0, t('labTests.antiTpo.validation.minValue'))
      .max(100000, t('labTests.antiTpo.validation.maxValue')),
    testedAt: Yup.date().required(t('validation/required')),
  });

export default validationSchema;
